import { showNotification } from "@/entities/notification"
import { registerNotification } from "@/shared/api/websocket"
import { thoughtKeys } from "../api/keys"

registerNotification("diary_entry", {
	handle: ({ notification_id }, ctx) => {
		showNotification({
			type: "silent",
			placement: null,
			origin: "server",
			notificationId: notification_id,
			name: "diary_entry",
		})
		ctx.queryClient.invalidateQueries({
			queryKey: thoughtKeys.list(ctx.userId),
		})
	},
	route: () => ({ to: "/diary" }),
	routePopup: null,
})
